module.exports = __webpack_public_path__ + "img/10.e6fd44f5.png";